import { 
  CashbackIcon, cashbackIcon, discountIcon, experienceIcon, giftCardIcon, membershipIcon, Subscription 
} from "../assets/svg/index.js";

import { Sun, CloudSun ,Sunrise, CloudMoon, User } from 'lucide-react';

import { PRECIOUS_METALS, REWARD_LISTING, SUBSCRIPTION_LISTING, TRAVEL_MODULE, USER_PROFILE } from "../Routes/RoutesContant.js";

export const TABMAPPING = (rewardConfig) => ({
  merchant_funded_offers: { title: rewardConfig?.merchant_funded_offers_text || "Discount Offers", Icon: discountIcon },
  subscription: { title: rewardConfig?.subscription_text || "Subscription Offer", Icon: membershipIcon },
  affiliate_cashback: { title: rewardConfig?.affiliate_cashback_text || "Cashback", Icon: cashbackIcon },
  gift_card: { title: rewardConfig?.gift_card_text || "Gift Cards", Icon: giftCardIcon },
  access_n_membership: { title: rewardConfig?.access_n_membership_text || "Access & Membership", Icon: membershipIcon },
  experiences: { title: rewardConfig?.experiences_text || "Experiences", Icon: experienceIcon },
});

// Helper to move "Others"/"other"/"Other"/"others" to the end
export const moveOthersToEnd = (list) => {
  if (!Array.isArray(list)) return [];
  return [
    ...list.filter(item => !/^others?$/i.test(item.name.trim())),
    ...list.filter(item => /^others?$/i.test(item.name.trim())),
  ];
};

export const CATEGORY = "CATEGORY";
export const BRAND_CATEGORY = "BRAND_CATEGORY";
export const SUPER_CATEGORY = "SUPER_CATEGORY";  
export const BOTH = "BOTH";

// constant for offer_type 
export const cardTitleToPath = (cardTitle) => {
  const pathMapping = {
    gift_card: "giftcard",
    affiliate_cashback: "cashback",
    merchant_funded_offers: "discount",
    access_n_membership: "membership",
    experiences: "experience",
    subscription: "subscription"
  };
  return pathMapping[cardTitle] || "/";
};

export const getOfferType = (key) => {
  const OfferType = {
    merchant_funded_offers: "Discount Offers",
    affiliate_cashback: "Cashback",
    gift_card: "Gift Cards",
    access_n_membership: "Access & Membership",
    experiences: "Experiences",
    subscription: "Subscription"
  };
  return OfferType[key] || null;
};

export const getOfferTypeResultAPI = (key) => {
  const OfferType = {
    "discount": "merchant_funded_offers",
    "cashback": "affiliate_cashback",
    "giftcard": "gift_card",
    "membership": "access_n_membership",
    "experience": "experiences",
    "subscription" : "subscription"
  };
  return OfferType[key] || null;
};

const IST_OFFSET = 330;
const DATE_FORMAT = 'YYYY-MM-DD';
const DISPLAY_DATE_FORMAT = 'ddd, DD MMM';

export { DATE_FORMAT, DISPLAY_DATE_FORMAT, IST_OFFSET };

// Data structure for the different offer types
const OfferTypes = {
  gift_card: {
    title: "Gift Cards",
    Icon: giftCardIcon,
    key: "gift_card",
    name: "Gift Card"
  },
  merchant_funded_offers: {
    title: "Discount Offers",
    Icon: discountIcon,
    key: "merchant_funded_offers",
    name: "Discount Offer"
  },
  affiliate_cashback: {
    title: "Cashback",
    Icon: cashbackIcon,
    key: "affiliate_cashback",
    name: "Cashback"
  },
  access_n_membership: {
    title: "Access & Membership",
    Icon: membershipIcon,
    key: "access_n_membership",
    name: "Access & Membership"
  },
  experiences: {
    title: "Experiences",
    Icon: experienceIcon,
    key: "experiences",
    name: "Experience",
  },
  subscription: {
    title: "Subscription Offers",
    Icon: membershipIcon,
    key: "subscription",
    name: "Subscription Offer"
  },
};

// Function to get offer type based on the key
export const getOfferTypeResult = (key) => {
  // Return the object with title, icon, and key based on the key provided
  return OfferTypes[key] || null;
};

export const EmptyMessagemap = {
  all_rewards: "No rewards found.",
  gift_card: "No gift card offers found.",
  merchant_funded_offers: "No discount offers found.",
  affiliate_cashback: "No cashback offers found.",
  access_n_membership: "No Access and membership rewards found.",
  experiences: "No experiences found.",
  subscription: "No subscription offers found.",
};

// Module tab section 
export const MODULETABS = [
  { id: "reward", title: "Rewards", path: REWARD_LISTING, icon: CashbackIcon },
  { id: "subscription", title: "Subscription", path: SUBSCRIPTION_LISTING, icon: Subscription },
  { id: "travel", title: "Travel", path: TRAVEL_MODULE, icon: Subscription },
  // { id: "commerce", title: "Commerce", path: COMMERCE_MODULE, icon: Subscription },
  // { id: "membership", title: "VIP", path: VIP_MODULE, icon: Subscription },
  // { id: "experience", title: "Experience", path: EXPERIENCE_MODULE, icon: Subscription },
  {id: "precious_metals", title: "Precious Metals", path: PRECIOUS_METALS, icon: Subscription},
  { id: "my_account", title: "My Account", path: USER_PROFILE, icon: User },
];

// Keep component imports out of this constants module to avoid utility/component import cycles.
export const moduleMapping = {};

export const MODULE_TYPES = {
  SUBSCRIPTION: 'subscription',
  TRAVEL: 'travel',
  REWARD: 'reward',
  LOYALTY: 'loyalty',
  MEMBERSHIP: 'membership',
  EXPERIENCE: 'experience',
  COMMERCE: 'commerce'
};

export const RedemptionRewardListing = [
  {
    id: "ONLINE",
    name: "Online",
  },
  {
    id: "OFFLINE",
    name: "Offline",
  },
];
export const TRAVEL_SUBMODULE_PATH_TO_TAB_INDEX = {
  'flight': 0,
  'hotel': 1,
  'train': 2,
  'bus': 3
};

export const TRAVEL_SUBMODULE = {
  FLIGHT: "flight",
  TRAIN: "train",
  BUS: "bus",
  HOTEL: "hotel"
}

export const FLIGHT_CLASS_CONSTANT = {
  ECONOMY: 'ECONOMY',
  PREMIUM_ECONOMY: 'PREMIUM_ECONOMY',
  FIRST: 'FIRST',
  BUSINESS: 'BUSINESS',
}

export const FLIGHT_CLASS = [
  { value: FLIGHT_CLASS_CONSTANT.ECONOMY, label: 'Economy' },
  { value: FLIGHT_CLASS_CONSTANT.PREMIUM_ECONOMY, label: 'Premium Economy' },
  { value: FLIGHT_CLASS_CONSTANT.FIRST, label: 'First Class' },
  { value: FLIGHT_CLASS_CONSTANT.BUSINESS, label: 'Business' },
]

export const FLIGHT_TRIP_CONSTANT = {
  ONEWAY: 'ONEWAY',
  ROUNDTRIP: 'ROUNDTRIP',
  MULTICITY: 'MULTICITY',
}

export const FLIGHT_TRIP_CATEGORIES = [
  { value: FLIGHT_TRIP_CONSTANT.ONEWAY, label: 'One Way' },
  { value: FLIGHT_TRIP_CONSTANT.ROUNDTRIP, label: 'Round Trip' },
  { value: FLIGHT_TRIP_CONSTANT.MULTICITY, label: 'Multi City' },
]

export const AIRPORTS = [
  { iata_code: "DEL", name: "Indira Gandhi International Airport", city: "New Delhi", state: "Delhi", country: "India" },
  { iata_code: 'BOM', name: 'Chhatrapati Shivaji International Airport', city: 'Mumbai', state: "Maharashtra", country: "India" },
  { iata_code: 'BLR', name: 'Kempegowda International Airport', city: 'Bengaluru', state: "Karnataka", country: "India" },
  { iata_code: 'MAA', name: 'Chennai International Airport', city: 'Chennai', state: "Tamil Nadu", country: "India" },
  { iata_code: 'CCU', name: 'Netaji Subhas Chandra Bose International Airport', city: 'Kolkata', state: "West bengal", country: "India" }
];

export const DEFAULT_TRAVEL_COUNT = {
  adults: 1,
  children: 0,
  infants: 0
}

export const TRAVELLER_DEFAULT_MAP = [
  { type: 'adults', label: 'Adults', age: '(12+ Years)', min: 1, max: 9 },
  { type: 'children', label: 'Children', age: '(2-12 Years)', min: 0, max: 9 },
  { type: 'infants', label: 'Infant', age: '(0-2 Years)', min: 0, max: 9 }
];

export const TIMESLOTS = [
  { label: 'Before 6 AM', value: "00:00-06:00", Logo: Sunrise },
  { label: '6 AM - 12 PM', value: '06:00-12:00', Logo: Sun },
  { label: '12 PM - 6 PM', value: '12:00-18:00', Logo: CloudSun },
  { label: 'After 6 PM', value: '18:00-24:00', Logo: CloudMoon },
];

export const STOPS = {
  oneStop: "One Stop",
  nonStop: "Non Stop",
  twoPlusStops: "2+ Stops"
};

export const FLIGHT_IMAGE_URL = (airlineCode) => `https://flight.easemytrip.com/Content/AirlineLogon/${airlineCode}.png`;

export const FLIGHT_DETAIL_TABS = [
  {
    title: "FARE_DETAIL",
    display_name: "Fare Detail",
  },
  {
    title: "CANCELLATION_AND_CHANGE_RULE",
    display_name: "Cancellation & Change Rule",
  },
  {
    title: "BAGGAGE",
    display_name: "Baggage Information",
  },
];

export const ADULT_TITLE_OPTIONS = [
  { value: "Mr", label: "Mr" },
  { value: "Ms", label: "Ms" },
  { value: "Mrs", label: "Mrs." },
];

export const CHILD_AND_INFANT_TITLE_OPTIONS = [
  { value: "Ms", label: "Miss" },
  { value: "Mr", label: "Master" },
];

export const TRAVELER_TYPES = {
  ADULT: "Adult",
  CHILD: "Child",
  INFANT: "Infant",
};

export const getTravellerTypeKey = (type) => {
  const typeMap = {
    [TRAVELER_TYPES.ADULT]: "AdultTraveller",
    [TRAVELER_TYPES.CHILD]: "ChildTraveller",
    [TRAVELER_TYPES.INFANT]: "InfantTraveller",
  };
  return typeMap[type];
};

export const HOMEPAGE = "homepage";
export const PRIVACY = "privacy";
export const CONTACT = "contact";
export const TERMS = "terms";
export const FAQ = "faq";
export const DISCLAIMER = "disclaimer";
export const COOKIE = "cookie";
export const PROFILE = "profile";
export const ORDERS = "orders";
export const REWARDS = "rewards";
export const WISHLIST = "wishlist";
export const SUBSCRIPTION = "subscription";
export const REWARD = "reward";
export const VIP = "vip";
export const EXPERIENCE = "experience";
export const COMMERCE = "commerce";
export const TRAVEL = "travel";
export const PRECIOUSMETAL = "preciousmetal";
